import { render } from "./LoginRecoverAlternative.vue?vue&type=template&id=7c87c938&scoped=true"
import script from "./LoginRecoverAlternative.vue?vue&type=script&lang=js"
export * from "./LoginRecoverAlternative.vue?vue&type=script&lang=js"

import "./LoginRecoverAlternative.vue?vue&type=style&index=0&id=7c87c938&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c87c938"]])

export default __exports__